<template>
  <ul class="amenities-filter-list">
    <li class="amenity-item" v-for="amenity in amenities" :key="amenity.ota_code">
      <Checkbox
          v-model="selectedAmenities"
          :inputId="`amenity${amenity.ota_code}`"
          :value="amenity.ota_code"
          @update:modelValue="selectAmenity"/>
      <label :for="`amenity${amenity.ota_code}`">{{ amenity.name }}</label>
    </li>
  </ul>
</template>

<script setup lang="ts">
import Checkbox from "primevue/checkbox";
import {useSearchStore} from "~/store/search";
import { useRoute } from "vue-router";

const searchStore = useSearchStore();
const route = useRoute();
//define emits

const emit = defineEmits(['update']);
//define props

const amenities = computed(() => {
  const source = searchStore.filters?.amenities;
  const list = Array.isArray(source)
    ? source
    : Array.isArray(source?.items)
      ? source.items
      : [];

  return [...list].sort((a, b) => Number(a?.ota_code ?? 0) - Number(b?.ota_code ?? 0));
})

const selectedAmenities = ref([] as string[])

onMounted(() => {
  selectedAmenities.value = (route?.query?.amenities as string)?.split(',') || [];
})

watch(
  () => route.query.amenities,
  (value) => {
    if (!value) {
      selectedAmenities.value = [];
      return;
    }

    if (Array.isArray(value)) {
      selectedAmenities.value = value.filter(Boolean) as string[];
      return;
    }

    selectedAmenities.value = (value as string).split(',').filter(Boolean);
  }
);

watch(
    () => amenities.value,
    (newAmenities) => {
      if (!newAmenities?.length) return;
      if (selectedAmenities.value.length) return;
      selectedAmenities.value = (route?.query?.amenities as string)?.split(',') || [];
    },
    { immediate: false },
)


function selectAmenity() {
  emit('update', selectedAmenities.value);
}

</script>

<style scoped lang="scss">
.amenities-filter-list {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .amenity-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
